import { CanvasElement, Point } from "./schemas";
import { IntegrationItem, integrationItemSchema } from "./schemas/integration-item";
import { IntegrationType } from "../integrations/integration";
import { ReadonlyJSONObject, WriteTransaction } from "@workcanvas/reflect";
import { canvasElementPrefix, getUnixTimestampUTC, authenticatedPut, createElementId } from "../util/utils";

interface IntegrationItemBase extends CanvasElement {
  fieldValues?: any;
  fromDate?: number;
  toDate?: number;
}
export function placeIntegrationElement<T extends IntegrationItemBase>(
  { x, y }: Point,
  integrationId: string,
  integrationType: IntegrationType,
  configuration: any,
  baseOnElement?: T
) {
  const id = createElementId();
  const fill = (baseOnElement as any)?.color || (baseOnElement as any)?.fill;
  return {
    id,
    type: "integrationItem",
    item: integrationItemSchema.parse({
      ...(baseOnElement ?? {}),
      fill,
      type: "integrationItem",
      x,
      y,
      scaleX: 1,
      scaleY: 1,
      zIndexLastChangeTime: getUnixTimestampUTC(),
      integrationId,
      integrationType,
      configuration,
      fieldValues: {
        ...(baseOnElement?.fieldValues ?? {}),
        fromDate: baseOnElement?.fromDate,
        toDate: baseOnElement?.toDate,
      },
    }) as IntegrationItem,
  };
}

export async function updateIntegrationItemConfiguration(
  tx: WriteTransaction,
  { id, configuration }: { id: string; configuration: any }
): Promise<void> {
  const element = await tx.get(key(id));
  if (element) {
    const { configuration: oldConfig, ...rest } = element as any;
    rest.configuration = { ...oldConfig, ...configuration };
    await putElement(tx, { id, element: rest });
  }
}

function putElement(tx: WriteTransaction, { id, element }: { id: string; element: IntegrationItem }): Promise<void> {
  const next = { ...(element as ReadonlyJSONObject), lastModifiedTimestamp: getUnixTimestampUTC() };
  return authenticatedPut(tx, key(id), next);
}

function key(id: string): string {
  return `${canvasElementPrefix}${id}`;
}
